// extracted by mini-css-extract-plugin
export default {"window":"Deals_window__6mvVk"};